import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.11@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-order_fill",
  "use": "icon-order_fill-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-order_fill\"><path d=\"M640 479.968h-256a32 32 0 0 1 0-64h256a32 32 0 0 1 0 64m0 160h-256a32 32 0 0 1 0-64h256a32 32 0 0 1 0 64M800.256 128H223.744A64 64 0 0 0 160 192.064v639.84A64 64 0 0 0 223.744 896h576.512A64 64 0 0 0 864 831.904V192.064A64 64 0 0 0 800.256 128\" p-id=\"3191\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol